import React, { useEffect } from "react";
import { connect } from "react-redux";
import { logout, verifyOTP } from "../../features/Login/redux/action";
import { Capacitor } from "@capacitor/core";
import moment from "moment";
import { App } from "@capacitor/app";
import { setLoading } from "../redux/action";

// export default ReloadData;
class ReloadData extends React.Component {
  state = {
    timeoutId: null,
  };
  timeOut = null;

  componentDidMount() {
    App.addListener("appStateChange", async (state) => {
        if (state.isActive) {
            // console.log("if state is active")
            // clearTimeout(this.state.timeoutId);
            this.fetchData();
      }
    });
    console.log("Props => ",this.props)
    this.fetchData();
  }

  componentWillUnmount() {
    clearTimeout(this.timeOut);
  }

  reloadData() {
    let lastReloadTime =
      this.props?.user?.parent == "Mother"
        ? this.props.user?.last_mother_mobile_reload
        : this.props.user?.last_father_mobile_reload;
      if (moment(lastReloadTime).isValid()) {
          const now = moment();
          console.log("if last Reload Time: ",lastReloadTime)
         let givenTime = moment(
           moment(lastReloadTime, "YYYY-MM-DDTHH:mm:ss")
         );
        const difference = now.diff(givenTime, "minutes");
      console.log("Difference in minutes " + difference);
      if (difference > 5) {
        console.log("In if condition");
        this.fetchData();
      } else {
        const newTimeoutId = setTimeout(
          this.fetchData(),
          difference * 60 * 1000
        );
        this.setState({ timeoutId: newTimeoutId });
      }
    }
  }
  fetchData() {
    this.props.verifyOTP("999999", false, true, (response) => {
      console.log("Response => ", response);
      if (response && response.survey && response.survey.survey_id > 0) {
        console.log("Redirecting to survey ");
        window.location.href = `survey/${response.survey.survey_id}`;
      }
    }, async () => {
      this.props.loading(true);
      await this.props.logout();
      await App.removeAllListeners();
      // this.timeOut=  setTimeout(() => {
      // // this.props.loading(false);
      //   window.location.href = `login`;
      // },2000)
      this.props.history.replace('/');
    });
  }
  render() {
    return null;
  }
}

const mapStateToProps = (state) => {
    const activeChildDetail =
        state.userState.user && state.userState.user.activeChildDetail;
    return {
        user: activeChildDetail,
        loading: state.global.showLoading,
    };
};

const mapDispatchToProps = (dispatch) => ({
    verifyOTP: (otp, verify, reload, onSuccess, onError) =>
    dispatch(verifyOTP(otp, verify, reload, onSuccess, onError)),
    logout: () => dispatch(logout()),
  loading: (load) => dispatch(setLoading(load)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReloadData);
